module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/phone-58459cf48059a5e8f85ede5e6b6fd72d.webp";